export const API_URL = process.env.REACT_APP_API_URL;
export const downloadFile = async (fileUrl) => {
    if(!fileUrl||fileUrl.endsWith('.com')) return;
    try {
        // Ensure the URL is properly encoded (if needed)
        const encodedUrl = encodeURIComponent(fileUrl);

        const response = await fetch(`${API_URL}remotefittinginquires/download?url=${encodedUrl}`);

        if (!response.ok) {
            throw new Error('Failed to fetch the file');
        }

        const blob = await response.blob();
        const filename = fileUrl.split('/').pop(); // Extract filename from the URL

        // Create a temporary anchor tag to download the file
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } catch (error) {
        console.error('Download error:', error);
    }
};





